import { apiSlice } from '../../store/api/apiSlice';
import { encryptData } from '../../shared/services/cryptoService';

const isLocalOrStaging = ['LOCAL', 'STAGING'].includes(
  process.env.REACT_APP_API_environment || ''
);

export const loginApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    emisLogin: builder.mutation<
      any,
      { records: { emis_username: string; emis_password: string } }
    >({
      query: (payload) => ({
        url: isLocalOrStaging ? 'api/emislogin' : 'api/testlogin',
        method: 'POST',
        body: payload,
        service: 'loginApiUrl',
      }),
    }),

    getEmisReactDetails: builder.query<any, { userName: string }>({
      query: ({ userName }) => ({
        url: 'GetEmisReactDetails',
        method: 'GET',
        params: {
          username: userName,
        },
        service: 'djangoEmis',
      }),
    }),
    resetPassOtpSubmit: builder.mutation({
      query: (payload) => {
        const encryptedPayload = encryptData(payload);

        return {
          url: 'api/ResetPassOtpSubmit',
          method: 'POST',
          body: encryptedPayload,
          service: 'php1',
        };
      },
    }),

    forgotPasswordOtp: builder.mutation({
      query: (payload) => {
        console.log('before encrypting', payload);
        const encryptedPayload = encryptData(payload);

        console.log('Encrypted Payload:', encryptedPayload);

        return {
          url: 'api/ForgotPasswordOtp',
          method: 'POST',
          body: encryptedPayload,
          service: 'phpTntp',
        };
      },
    }),

    forgotPassUpdate: builder.mutation({
      query: (payload) => ({
        url: 'api/ForgotPassUpdate',
        method: 'POST',
        body: encryptData(payload),
        service: 'php1',
      }),
    }),
  }),
});

export const {
  useEmisLoginMutation,
  useLazyGetEmisReactDetailsQuery,
  useForgotPasswordOtpMutation,
  useResetPassOtpSubmitMutation,
  useForgotPassUpdateMutation,
} = loginApi;
